module.exports = __webpack_public_path__ + "img/pickupdumping_stopped.5d30a4fa.svg";